module.exports = {"540232100":"帕羊镇","540232200":"拉让乡","540232201":"帕江乡","540232202":"仁多乡","540232203":"吉玛乡","540232204":"隆格尔乡","540232205":"霍尔巴乡","540232206":"吉拉乡","540232207":"纳久乡","540232208":"偏吉乡","540232209":"布多乡","540232210":"亚热乡","540232211":"琼果乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540232.json
// module id = 2503
// module chunks = 0